<template>
  <div class="home">
    <title class=".display-1 title">Witaj na stronie startowej!</title>
    <v-container>
      <v-row class="mt-6">
        <v-col cols="4">
          <router-link :to="{ name: 'Configurator' }">
            <v-img class="" src="/assets/kalkulator.png"></v-img>
          </router-link>
        </v-col>
        <v-col cols="4">
          <router-link :to="{ name: 'Elevation' }">
            <v-img class="" src="/assets/kalkulator_elewacja.png"></v-img>
          </router-link>
        </v-col>
        <v-col cols="4">
          <router-link :to="{ name: 'ManualOrder' }">
            <v-img class="" src="/assets/order.png"></v-img>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.home {
  min-height: 600px;
}
.home > .title {
  text-align: center !important;
}
</style>
